import { useMutation } from "react-query";
import getOrg from "../services/getOrg";

const useGetOrgMutation = () => {
  return useMutation(["get-org"], getOrg);
};

export default useGetOrgMutation;
